export default [
  {
    name: 'payments/detail/form', // 수정
    path: '/payments/:uuid/form',
    component() {
      return import('@/pages/payments/UpdateForm.vue')
    },
  },
  {
    name: 'payments/form', //등록
    path: '/payments/form',
    component() {
      return import('@/pages/payments/RegisterForm.vue')
    },
  },
  {
    name: 'payments/detail', // 상세보기
    path: '/payments/:uuid',
    meta: {
      requireSignin: false,
    },
    component() {
      return import('@/pages/payments/Detail.vue')
    },
  },
]
